import script from "./ProceedingsAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceedingsAdd.vue?vue&type=script&setup=true&lang=js"

import "./ProceedingsAdd.vue?vue&type=style&index=0&id=6ace046e&lang=scss"

const __exports__ = script;

export default __exports__